import type { ReactNode } from 'react';

export type SummaryTone = 'default' | 'good' | 'warn' | 'bad';

const TONE: Record<SummaryTone, string> = {
  default: 'text-slate-900',
  good: 'text-[#047857]',
  warn: 'text-[#b45309]',
  bad: 'text-[#be123c]',
};

export interface SummaryItem {
  label: string;
  value: ReactNode;
  sub?: string;
  tone?: SummaryTone;
  /** 0-100; renders a thin progress bar under the value when set. */
  progressPct?: number;
}

export function DhSummaryStrip({ items }: { items: SummaryItem[] }) {
  return (
    <div
      className="mb-4 grid overflow-hidden rounded-2xl border border-[#e8edf1] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.03)]"
      style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
    >
      {items.map((it, i) => (
        <div key={it.label} className={`px-4 py-3 ${i > 0 ? 'border-l border-[#f1f5f9]' : ''}`}>
          <div className="text-[10px] font-bold uppercase tracking-[0.1em] text-[#94a3b8]">{it.label}</div>
          <div className={`mt-1 text-[21px] font-bold tracking-tight ${TONE[it.tone ?? 'default']}`}>{it.value}</div>
          {typeof it.progressPct === 'number' && (
            <div className="mt-2 h-1 overflow-hidden rounded-full bg-[#eef2f6]">
              <div className="h-full rounded-full bg-[#006346]" style={{ width: `${it.progressPct}%` }} />
            </div>
          )}
          {it.sub && <div className="mt-0.5 text-[10.5px] text-[#aab4bf]">{it.sub}</div>}
        </div>
      ))}
    </div>
  );
}
